$(document).ready(function () {
  productSlickSlideshow();
  
  $(document).on("click", ".add-to-cart-sub-btn", function (e) {
    e.preventdefault;
    var isStatus = false;
    var count = 1;
    
    $(this).find("[data-add-to-cart-text]").html("Customizing Product...");
      if ($(".checkbox-dropdown .checkbox:checked").length > 0) {
        svgToPngBase64($(".checkbox-dropdown .checkbox:checked").eq(0), count);
      } else {
        update_cart_item();
        // $(".add-to-cart").trigger("click");
      }
  });

  // document.addEventListener("ajaxProduct:added", function (evt) {
  //   var addUpchargeProduct = addUpdateUpchargeProduct();
  //   addUpchargeProduct.then(function(res) {
  //      console.log(res);
  //   });
  // });
  // document.addEventListener("cart:updated", function (evt) {
  //   var addUpchargeProduct = addUpdateUpchargeProduct();
  //   addUpchargeProduct.then(function(res) {
  //      console.log(res);
  //   });
  // });
});

// async function addUpdateUpchargeProduct() {
//   const upchargeHandle = 'single-product-upcharge'; // Replace with your actual upcharge product handle
//   let cart = await fetch('/cart.js').then(res => res.json());
//   // Filter out personalization/logo items
//   const validItems = cart.items.filter(item => {
//     const props = item.properties || {};
//     const isUpcharge = item.handle === upchargeHandle;
//     const ispersonalize = item.handle === 'personalization';
//     const isLogo = item.handle === 'embroidery';
//     const isPersonalization = item.handle === 'additional-logo-locations';
//     return !isUpcharge && !isLogo && !ispersonalize && !isPersonalization ;
//   });
//   const upchargeItem = cart.items.find(item => item.handle === upchargeHandle);
//   const validItemsNew = cart.items.filter(item => {
//     const props = item.properties || {};
//     const isUpcharge = item.handle === upchargeHandle;
    
//       return isUpcharge;
//   });
//   console.log(validItems);
//   if (validItems.length === 1 && validItems[0].quantity === 1) {
//     // let logoCount = false; 
//     // let personalizationCount = false;
//     // $.each(cart.items, function(index, item) {
//     //   var properties = item["properties"];
//     //     for (const logoKey in properties) {  
//     //       var logoValue = properties[logoKey];
//     //       if (logoKey.toLowerCase().startsWith("logo") && logoValue.trim() !== "") {
//     //         logoCount = true;
//     //       }
           
//     //       if (logoKey.toLowerCase().startsWith("_personalization") && logoKey.toLowerCase().includes("coordinates") && logoValue.trim() !== "") {
//     //         personalizationCount = true;
//     //       }        
//     //     }
//     // });
//     //if(!logoCount && !personalizationCount){
//       const singleItem = validItems[0];
//       const itemPriceCents = singleItem.final_line_price;;
//       const upchargeQty = Math.ceil((itemPriceCents * 0.10) / 100); // convert to dollars, round up
  
  
//       // Fetch upcharge product info
//       const product = await fetch(`/products/${upchargeHandle}.js`).then(res => res.json());
//       const matchedVariant = product.variants.filter(v => v.title === `$${upchargeQty}`)[0];
//       const upchargeVariantId = matchedVariant ? matchedVariant.id : null;
//       console.log(product)
    
//       // const [personalizaLogoLocation_id] = await Promise.all([
//       //   getProductByHandle(upchargeHandle, "id", "first", "")
//       // ]); 
   
//       // Filter out personalization/logo items
      
//       // console.log(additionalLogoLocation_id);
//       const response = {
//         "personalizaLogoLocation": { "id": upchargeVariantId, "quantity": 1 }
//       };
   
//       const updates = Object.keys(response).reduce((acc, key) => {
//         const product = response[key];
//         const product_id = product.id.toString();
//         acc[product_id] = product.quantity; 
//         return acc;
//       }, {});
   
//       if (Object.keys(updates).length > 0) {
//         $.ajax({
//           url: `${window.Shopify?.routes?.root??"/"}cart/update.js`,
//           type: 'POST',
//           dataType: 'json',
//           data: { updates: updates },
//           success: function(cart) { 
//             document.dispatchEvent(new CustomEvent("cart:build"));
//             // cartRefreshHtml();
//           },
//           error: function(err) {
//             console.error('Error adding products to cart:', err);
//           }
//         });
//       }
//       return response;
//    // }
//   } else {
//     // If condition doesn't match, remove any existing upcharge product
//     if (upchargeItem) {
//       const product = await fetch(`/products/${upchargeHandle}.js`).then(res => res.json());
//       //  const matchedVariant = product.variants.filter(v => v.title === `$${upchargeQty}`)[0];
//       // const upchargeVariantId = matchedVariant ? matchedVariant.id : null;
      
//       // const [personalizaLogoLocation_id] = await Promise.all([
//       // getProductByHandle(upchargeHandle, "id", "first", "")
//       // ]); 
//       // console.log(additionalLogoLocation_id);
//       const response = {
//       "personalizaLogoLocation": { "id": validItemsNew[0].variant_id, "quantity": 0 }
//       };
      
//       const updates = Object.keys(response).reduce((acc, key) => {
//       const product = response[key];
//       const product_id = product.id.toString();
//       acc[product_id] = product.quantity; 
//       return acc;
//       }, {});
      
//       if (Object.keys(updates).length > 0) {
//       $.ajax({
//         url: `${window.Shopify?.routes?.root??"/"}cart/update.js`,
//         type: 'POST',
//         dataType: 'json',
//         data: { updates: updates },
//         success: function(cart) { 
//           document.dispatchEvent(new CustomEvent("cart:build"));
//           // cartRefreshHtml();
//         },
//         error: function(err) {
//           console.error('Error adding products to cart:', err);
//         }
//       });
//       }
//       return response;
//     }
//   }
// }

function getProductByHandle(product_handle, res_type, type, sku) {
  return new Promise(function(resolve, reject) {  
      jQuery.getJSON('/products/' + product_handle + '.js', function(product) {  
          var resProduct = ""; 
          if(res_type == 'id'){ 
            if (type === 'first') { 
                resProduct = product.variants[0].id;
            } else if (type === 'sku' && sku !== '') { 
                $.each(product.variants, function(index, item) {
                    if (item.sku === sku) {
                        resProduct = item.id;
                        return false;
                    }
                });
            }
          }else{
            if (type === 'first') { 
                var variantsData = product.variants[0];
                variantsData.product_id = product.id; 
                resProduct = variantsData;
            } else if (type === 'sku' && sku !== '') { 
                $.each(product.variants, function(index, item) {
                    if (item.sku === sku) {
                        item.product_id = product.id;
                        resProduct = item;
                        return false;
                    }
                });
            }
          }
          if (resProduct === '') {
              resProduct = product;
          } 
          resolve(resProduct);
      }).fail(function(error) {  
          reject('Error fetching product data: ' + error.statusText);
      });
  });
}
function productSlickSlideshow() {
   $(".custom-product-slideshow").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    useTransform: true,
    asNavFor: ".product_custom_thumbs_scroller"
  });
  $(".product_custom_thumbs_scroller").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite:true,
    asNavFor: ".custom-product-slideshow",
    dots: false,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
      }
    }, {
      breakpoint: 640,
      settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
      }
    }, {
        breakpoint: 589,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
    }
    }]
  });
}

$(document).on("click", "#clear-cart-button", function(e) {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(response => {
    if (response.ok) { 
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          document.dispatchEvent(new CustomEvent('cart:build'));
        });
    } else {
      console.error('Failed to clear cart.');
    }
  }).catch(error => console.error('Error:', error));
});

function svgToPngBase64(thisObj, count) {
  var is_checked = thisObj.prop("checked");
  var loValue = thisObj.attr("data-location");

  if (is_checked == true) {
    var fullSvgImage = $(".full_image_" + loValue).html();
    var logoSvgImage = $(".full_image_" + loValue)
      .find(".logo-image-svg")
      .html();
    var tamlength = $(".checkbox-dropdown .checkbox:checked").length;
    var courseLogo = $(".data_logo_input_" + loValue + ":checked").val();

    if (fullSvgImage != "" || logoSvgImage != "") {
      var svgContent = ".full_image_" + loValue;
      const svg = document.querySelector(svgContent);
      const firstImage = svg.querySelector("image");
      const firstLogo = svg.querySelector("g.logo-image-svg");
      const svgText = svg.querySelector("g.logo-image-svg-text");

      var imageSource = "";
      if (firstImage) {
        var imageSource =
          firstImage.getAttribute("href") ||
          firstImage.getAttribute("xlink:href");
      } else {
        console.log("No image found in the SVG.");
      }

      // Base image URL
      const baseImageUrl = imageSource.trim();

      // Create a canvas and context
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      const canvas_logo = document.createElement("canvas");
      const context_logo = canvas_logo.getContext("2d");

      const canvas_text = document.createElement("canvas");
      const context_text = canvas_text.getContext("2d");

      // Load the base image
      const baseImage = new Image();
      baseImage.crossOrigin = "anonymous";
      baseImage.onload = function () {
        // Set canvas dimensions to match the base image
        canvas.width = baseImage.width;
        canvas.height = baseImage.height;

        // Draw the base image onto the canvas
        context.drawImage(baseImage, 0, 0);

        if ($(firstLogo).text().trim() == "Personalize") {
          if ($(svgText).text().trim() != "") {
            var svgTextElement = svgText.querySelector("text");
            // Add custom text
            const textX = $(svgTextElement).attr("x");
            const textY = $(svgTextElement).attr("y");
            const textWidth = $(svgTextElement).attr("width");
            const textHeight = $(svgTextElement).attr("height");
            const fontSize = $(svgTextElement).attr("font-size");
            const fontFamily = $(svgTextElement).attr("font-family");
            const fontColor = $(svgTextElement).attr("fill");

            // Set canvas size for text drawing
            canvas_text.width = parseInt(textWidth) + 200;
            canvas_text.height = 200 + parseInt(textHeight) / 2;

            // Loop through all <tspan> elements and render each line of text
            $(svgText)
              .find("tspan")
              .each(function () {
                var ttextX = $(this).attr("x"); // X position of the text
                var ttextY = $(this).attr("y"); // Y position of the text
                if ($(this).index() == 0) {
                  // var textYS = parseInt(textY) - parseInt(textHeight) / 2;
                  var textYS1 = 100;
                } else {
                  // var textYS = textY;
                  var textYS1 = 100 + parseInt(textHeight) / 2;
                }
                const svgTextData = $(this).text().trim();
                const fontSize = parseFloat($(this).attr("font-size") || $(svgTextElement).attr("font-size") || "30") + "px";
                const fontFamily = $(this).attr("font-family") || $(svgTextElement).attr("font-family") || "Arial";
                const fontColor = $(this).attr("fill") || $(svgTextElement).attr("fill") || "#000";

                let x = parseFloat($(this).attr("x")) || parseFloat($(svgTextElement).attr("x")) || 0;
                let y = parseFloat($(this).attr("y")) || parseFloat($(svgTextElement).attr("y")) || 0;

                // Check for transform at this tspan level (more precise)
                let transformAttr = $(this).attr("transform") || $(svgTextElement).attr("transform") || "";
                let rotate = 0, rotateX = x, rotateY = y;

                const rotateMatch = transformAttr.match(/rotate\(\s*(-?\d+\.?\d*)\s*,?\s*(-?\d+\.?\d*)?\s*,?\s*(-?\d+\.?\d*)?\s*\)/);
                if (rotateMatch) {
                  rotate = parseFloat(rotateMatch[1]);
                  if (rotateMatch[2]) rotateX = parseFloat(rotateMatch[2]);
                  if (rotateMatch[3]) rotateY = parseFloat(rotateMatch[3]);
                }

                // Draw on base canvas
                context.save();
                context.font = `${fontSize} ${fontFamily}`;
                context.fillStyle = fontColor;
                context.textBaseline = "middle";

                // Support SVG text-anchor for alignment
                const anchor = $(svgTextElement).attr("text-anchor") || "start";
                if (anchor === "middle") context.textAlign = "center";
                else if (anchor === "end") context.textAlign = "right";
                else context.textAlign = "left";

                context.translate(rotateX, rotateY);
                context.rotate((rotate * Math.PI) / 180);
                context.fillText(svgTextData, x - rotateX, y - rotateY);
                context.restore();

                // Optional canvas_text (no rotation, centered)
                // context_text.save();
                // context_text.font = `${fontSize} ${fontFamily}`;
                // context_text.fillStyle = fontColor;
                // context_text.textAlign = "center";
                // context_text.textBaseline = "middle";
                // context_text.fillText(svgTextData, canvas_text.width / 2, canvas_text.height / 2);
                // context_text.restore();
                context_text.font = `${fontSize} ${fontFamily}`;
                context_text.fillStyle = fontColor; // Text color
                context_text.fillText(
                  svgTextData,
                  canvas_text.width / 2 - parseInt(textWidth) / 2,
                  textYS1
                );
              });
          }
          console.log(canvas_text);
          // Convert the canvas to a Base64-encoded PNG image
          const finalImage = canvas.toDataURL("image/png");
          var finalImage_text = "";
          var finalImage_logo = "";
          if ($(svgText).text().trim() != "") {
            finalImage_text = canvas_text.toDataURL("image/png");
          }

          $.ajax({
            type: "POST",
            url: "https://qetail.com/apps/ecom_apps_uploadfile/convertImage.php",
            data: {
              courseLogo: courseLogo,
              fullSvgImage: fullSvgImage,
              logoSvgImage: logoSvgImage,
              fullPngImage: finalImage,
              logoPngImage: finalImage_logo,
              textPngImage: finalImage_text,
            },
            dataType: "json",
            success: function (response) {
              console.log(response);
              if (response.success) {
                $("#full_url_" + loValue).val(response.fullPngImage);
                if (response.logoPngImage != "") {
                  $("#logo_url_" + loValue).val(response.logoPngImage);
                } else {
                  $("#logo_url_" + loValue).val("");
                }
                if (response.textPngImage != "") {
                  $("#_personalization_" + loValue + "_text_image_url").val(
                    response.textPngImage
                  );
                }

                if (count == tamlength) {
                  update_cart_item();
                  return;
                }

                count = parseInt(count) + 1;
                svgToPngBase64(
                  $(".checkbox-dropdown .checkbox:checked").eq(
                    parseInt(count) - 1
                  ),
                  count
                );
              }
            },
            error: function () {
              alert("There was an error adding the item to the cart");
            },
          });
        } else {
          const firstLogoSvg = firstLogo.querySelector("svg");
          const svgData = $(firstLogo).html();

          // Create a Blob URL for the SVG
          const svgBlob = new Blob([svgData], {
            type: "image/svg+xml;charset=utf-8",
          });

          const svgUrl = URL.createObjectURL(svgBlob);

          const svgImage = new Image();
          svgImage.onload = function () {
            const x = parseInt($(firstLogoSvg).attr("x"));
            const y = parseInt($(firstLogoSvg).attr("y"));
            const width = parseInt($(firstLogoSvg).attr("width"));
            const height = parseInt($(firstLogoSvg).attr("height"));
            const rotate_angle = parseFloat($(firstLogoSvg).attr("rotate_angle"));
            const logo_width = 1024;
            const logo_height = 1024;
            

            canvas_logo.width = logo_width;
            canvas_logo.height = logo_height;

            if (rotate_angle != "" && rotate_angle > 0) {
              const angleInRadians = rotate_angle * Math.PI / 180;
              context.save();
              context.translate(x, y); 
              context.rotate(angleInRadians); 
              context.drawImage(svgImage, 0, 0, width, height); 
              context.restore();
            } else {
              context.drawImage(svgImage, x, y, width, height);
            }
            context_logo.drawImage(svgImage, 0, 0, logo_width, logo_height);

            if ($(svgText).text().trim() != "") {
              var svgTextElement = svgText.querySelector("text");
              const textWidth = $(svgTextElement).attr("width"); // width of the text
              const textHeight = $(svgTextElement).attr("height"); // height of the text
              // Set canvas size for text drawing
              canvas_text.width = parseInt(textWidth) + 200;
              canvas_text.height = 200 + parseInt(textHeight) / 2;

              $(svgText)
                .find("tspan")
                .each(function () {
                  var ttextX = $(this).attr("x"); // X position of the text
                  var ttextY = $(this).attr("y"); // Y position of the text
                  if ($(this).index() == 0) {
                    // var textYS = parseInt(textY) - parseInt(textHeight) / 2;
                    var textYS1 = 100;
                  } else {
                    // var textYS = textY;
                    var textYS1 = 100 + parseInt(textHeight) / 2;
                  }
                  const svgTextData = $(this).text().trim();
                  const fontSize = parseFloat($(this).attr("font-size") || $(svgTextElement).attr("font-size") || "30") + "px";
                  const fontFamily = $(this).attr("font-family") || $(svgTextElement).attr("font-family") || "Arial";
                  const fontColor = $(this).attr("fill") || $(svgTextElement).attr("fill") || "#000";

                  let x = parseFloat($(this).attr("x")) || parseFloat($(svgTextElement).attr("x")) || 0;
                  let y = parseFloat($(this).attr("y")) || parseFloat($(svgTextElement).attr("y")) || 0;

                  // Check for transform at this tspan level (more precise)
                  let transformAttr = $(this).attr("transform") || $(svgTextElement).attr("transform") || "";
                  let rotate = 0, rotateX = x, rotateY = y;

                  const rotateMatch = transformAttr.match(/rotate\(\s*(-?\d+\.?\d*)\s*,?\s*(-?\d+\.?\d*)?\s*,?\s*(-?\d+\.?\d*)?\s*\)/);
                  if (rotateMatch) {
                    rotate = parseFloat(rotateMatch[1]);
                    if (rotateMatch[2]) rotateX = parseFloat(rotateMatch[2]);
                    if (rotateMatch[3]) rotateY = parseFloat(rotateMatch[3]);
                  }

                  // Draw on base canvas
                  context.save();
                  context.font = `${fontSize} ${fontFamily}`;
                  context.fillStyle = fontColor;
                  context.textBaseline = "middle";

                  // Support SVG text-anchor for alignment
                  const anchor = $(svgTextElement).attr("text-anchor") || "start";
                  if (anchor === "middle") context.textAlign = "center";
                  else if (anchor === "end") context.textAlign = "right";
                  else context.textAlign = "left";

                  context.translate(rotateX, rotateY);
                  context.rotate((rotate * Math.PI) / 180);
                  context.fillText(svgTextData, x - rotateX, y - rotateY);
                  context.restore();

                  // Optional canvas_text (no rotation, centered)
                  // context_text.save();
                  // context_text.font = `${fontSize} ${fontFamily}`;
                  // context_text.fillStyle = fontColor;
                  // context_text.textAlign = "center";
                  // context_text.textBaseline = "middle";
                  // context_text.fillText(svgTextData, canvas_text.width / 2, canvas_text.height / 2);
                  // context_text.restore();
                  context_text.font = `${fontSize} ${fontFamily}`;
                  context_text.fillStyle = fontColor; // Text color
                  context_text.fillText(
                    svgTextData,
                    canvas_text.width / 2 - parseInt(textWidth) / 2,
                    textYS1
                  );
                });

            }

            // Revoke the Blob URL to free memory
            URL.revokeObjectURL(svgUrl);

            // Convert the canvas to a Base64-encoded PNG image
            const finalImage = canvas.toDataURL("image/png");
            const finalImage_logo = canvas_logo.toDataURL("image/png");
            var finalImage_text = "";
            if ($(svgText).text().trim() != "") {
              finalImage_text = canvas_text.toDataURL("image/png");
            }

            $.ajax({
              type: "POST",
              url: "https://qetail.com/apps/ecom_apps_uploadfile/convertImage.php",
              data: {
                courseLogo: courseLogo,
                fullSvgImage: fullSvgImage,
                logoSvgImage: logoSvgImage,
                fullPngImage: finalImage,
                logoPngImage: finalImage_logo,
                textPngImage: finalImage_text,
              },
              dataType: "json",
              success: function (response) {
                console.log(response);
                if (response.success) {
                  $("#full_url_" + loValue).val(response.fullPngImage);
                  if (response.logoPngImage != "") {
                    $("#logo_url_" + loValue).val(response.logoPngImage);
                  } else {
                    $("#logo_url_" + loValue).val("");
                  }
                  if (response.textPngImage != "") {
                    $("#_personalization_" + loValue + "_text_image_url").val(
                      response.textPngImage
                    );
                  }

                  if (count == tamlength) {
                    update_cart_item();
                    return;
                  }

                  count = parseInt(count) + 1;
                  svgToPngBase64(
                    $(".checkbox-dropdown .checkbox:checked").eq(
                      parseInt(count) - 1
                    ),
                    count
                  );
                }
              },
              error: function () {
                alert("There was an error adding the item to the cart");
              },
            });
          };
          svgImage.src = svgUrl;
        }
      };

      // Trigger loading base image
      baseImage.src = baseImageUrl;
    }
  }
}


$(document).on("click", ".meta_logo_logos_list", function(e) { 
  $('.collection-logo-list').show();
});

$(document).on("click", ".collection_logo_list_close_icon", function(e) {
  // $(".main_variant_logos_wrapper").attr("data-button-event","close"); 
  $(".main_variant_logos_wrapper").removeClass("sticky-active");
  $('.collection-logo-list').hide();
  $('.collection_logo_list_close_icon').hide();
});

$(document).ready(function() {
  var main_variant_logos_wrapper = document.querySelector(".main_variant_logos_wrapper");
  if (main_variant_logos_wrapper) { 
    var debounceTimeout;
    $(window).scroll(function() {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(function() { 
        $('.collection-title').each(function() {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
            if (elementBottom > viewportTop && elementTop < viewportBottom) {
              $('.collection_logo_list_close_icon').hide();
              $(main_variant_logos_wrapper).addClass('sticky-active');
               // $(".main_variant_logos_wrapper").attr("data-button-event", "sticky");
            }else{ 
              $('.collection_logo_list_close_icon').show();
            }
        });    
      }, 20);
    });
  }
 
  $(document).on("click", ".accordion", function (e) {
    e.preventdefault;
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next(".panel").slideUp("fast");
      $(this).find(".arrow svg").css("transform", "rotate(0deg)"); // Rotate arrow back to down
    } else {
      $(".accordion").removeClass("active");
      $(".panel").slideUp("fast");
      $(".accordion .arrow svg").css("transform", "rotate(0deg)"); // Reset all arrows to down

      $(this).addClass("active");
      $(this).next(".panel").slideDown("fast");
      $(this).find(".arrow svg").css("transform", "rotate(180deg)"); // Rotate arrow to up
    }
  });

  $(".input-personalize-text").on("keypress input", function (e) {
    const maxLines = 3;
    const maxCharsPerLine = 35;

    $("#error-message").hide();
    let value = $(this).val();
    let lines = value.split("\n");
    if (e.key === "Enter" && lines.length >= maxLines) {
      $("#error-message").text("Only "+maxLines+" lines allowed.").show();
      e.preventDefault();
      return;
    }
    
    for (let i = 0; i < lines.length; i++) {
      if (lines[i].length > maxCharsPerLine) {
        $("#error-message").text("Maximum "+maxCharsPerLine+" characters per line allowed.").show();
        lines[i] = lines[i].substring(0, maxCharsPerLine);
        $(this).val(lines.join("\n"));
        return;
      }
    }

    if (e.key === "Backspace" || e.inputType === "deleteContentBackward") {
      lines = $(this).val().split("\n");
      let trimmedLines = lines.map((line) =>
        line.substring(0, maxCharsPerLine)
      );

      if (trimmedLines.length > maxLines) {
        trimmedLines = trimmedLines.slice(0, maxLines);
        $("#error-message").text("Only "+maxLines+" lines allowed.").show();
      }
      $(this).val(trimmedLines.join("\n"));
    }
  });
});

document.addEventListener("DOMContentLoaded", function () { 
  let links = document.querySelectorAll(".grid-product__content a"); // Select all <a> elements
  let currentUrl = window.location.href;
  var mainurl = new URL(window.location.href); 
  links.forEach(link => {
      let href = link.getAttribute("href");
      if (href && currentUrl.includes("view_type=addOrder")) { 
        var order_page_type = "";
        if(currentUrl.includes("order_page_type=")){ 
          var orderPageType = mainurl.searchParams.get("order_page_type"); 
          if(orderPageType!=''){
            var order_page_type = "&order_page_type="+orderPageType;
          }
        }
        link.href = href + "&view_type=addOrder" + order_page_type;
      }
  });
});

function update_cart_item(){
   if (window.location.href.includes("view_type=addOrder")) { 
    let currentUrl = window.location.href;
    var mainurl = new URL(window.location.href); 
    let productForm = $(".product-single__form");
    let variantId = productForm.find("input[name='id']").val();
    let quantity = 1;
    let productTitle = $(".product-single__title").text();
    let productImage = $(".product-image-main").eq(0).find("image-element").find("image").attr("href");;
    let price = $(".product__price").text();
    let properties = propertiesSerializeForm(productForm);
    let cart = getCartDetails();
    var collection_product_url = $("#collection_product_url").val();
    var tmp_item_id = Date.now();
    cart.line_items.push({
        id: tmp_item_id, // Generate a unique ID
        variant_id: variantId,
        price: (meta.product.variants[0].price/100),
        quantity: quantity,
        title: productTitle,
        name: productTitle,
        images: {src: productImage},
        handle: collection_product_url.replace("/products/",""),
        product_id: meta.product.id,
        sku: meta.product.variants[0].sku,
        vendor:  meta.product.vendor,
        properties: properties
    });
    updateCartDetails(cart);

    var orderPageType = "";
    if(currentUrl.includes("order_page_type=")){ 
      orderPageType = mainurl.searchParams.get("order_page_type"); 
    }
    if(orderPageType!=""){
      window.location.href = "/account/orders/"+orderPageType;
    }else{
      window.location.href = "/pages/cart-details";
    }
  }else if(window.location.href.includes("pages/cart-details") || window.location.href.includes("account/orders")){ 
    let productForm = $(".product-single__form");
    var current_item_id = parseInt($("#current_item_id").val()); 
    let properties = propertiesSerializeForm(productForm);
    let cart = getCartDetails();
    cart.line_items.forEach((item, index) => {
      if (item.id === current_item_id) {
        if (cart.line_items[index].hasOwnProperty('properties') && Object.keys(cart.line_items[index].properties).length > 0) {
            // Merge existing properties with new properties
            cart.line_items[index]['properties'] = [ 
            //    ...cart.line_items[index]['properties'], 
                ...properties 
            ];
        } else {
            cart.line_items[index]['properties'] = properties;
        }
      }

    });  
    updateCartDetails(cart);
    autoFatchOrderDetails();
    $("#ajax_loader").show();
  }else{
   $(".add-to-cart").trigger("click");
  }
}

